@if (installationReportingResponse$ | async; as installationReportingResponse) {
  <div class="container">
    <ipo-modal
      [heading]="'ordersOverview.modalHeader' | translate"
      [maxWidth]="'95vw'"
      [width]="'fillWindow'"
      [fullHeight]="false"
      [closeable]="true"
      [confirmable]="true"
      [dismissString]="'report.dismiss' | translate"
      (dismiss)="closeModal()"
      [disabledProceedButton]="
        installationReportingResponse.isLoading ||
        installationReportingResponse.hasErrors ||
        installationReportingResponse.data?.length === 0
      "
      [proceedString]="'ordersOverview.downloadExcel' | translate"
      [isProceedLoading]="isDownloading"
      (proceed)="onDownloadExcel()"
    >
      @if (installationReportingResponse.isLoading) {
        <ipo-loading-spinner></ipo-loading-spinner>
      }
      @if (installationReportingResponse.data; as installationReports) {
        @if (installationReports.length) {
          <div>
            <div class="overview-table-control">
              <div class="filtering-component">
                <ipo-input
                  [placeholder]="
                    'ordersOverview.filterInputPlaceholder' | translate
                  "
                  [value]="filterText"
                  [label]="'ordersOverview.formFilterHeader' | translate"
                  [showSearchAndClearIcons]="true"
                  [type]="'text'"
                  (changed)="onFilterTextChanged($event)"
                ></ipo-input>
              </div>
              <div class="filtering-component">
                <app-installation-report-filter />
              </div>
            </div>
            <ng-container>
              <ng-container>
                <app-orders-overview-table
                  [ifsNumber]="ifs"
                  [installationReports]="installationReports"
                  [filterText]="filterText"
                  [filterFields]="filterFields"
                  [isLoading]="installationReportingResponse.isLoading"
                  (closeOrdersOverviewModal)="closeModal()"
                ></app-orders-overview-table>
              </ng-container>
            </ng-container>
          </div>
        }
        @if (
          installationReportingResponse.hasErrors ||
          (installationReportingResponse.isSuccess &&
            installationReports.length === 0)
        ) {
          <div>
            <ipo-icon-alert [type]="'warning'">
              {{ 'ordersOverview.error' | translate }}
            </ipo-icon-alert>
          </div>
        }
      }
    </ipo-modal>
  </div>
}
